import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  Z_INDEXS,
  SIDE_BAR,
} from '../../../themes'

export const StyleDetailRoom = styled.div`
  color: ${COLOR.BLACK_1};
  height: 100vh;
  position: absolute;
  top: 0;
  left: ${SIDE_BAR.WIDTH_SIZE};
  right: 0;
  bottom: 0;

  .gallery-btn {
    position: absolute;
    top: calc(50% + 18px);
    transform: translate(-50%, -50%);
    z-index: ${Z_INDEXS.LV_6};
    cursor: pointer;

    &-left {
      left: 0;
    }
    &-right {
      right: -36px;
    }
  }

  .button-circle {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: ${COLOR.WHITE};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    box-shadow: 0 0 2px ${COLOR.BLACK_3};
  }

  .scrollableContent {
    height: 100%;
    margin: 0em;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .container {
    /* max-height: calc(max-height - padding-top - padding-bottom); */
    max-height: calc(1080px - 52px - 100px);
    min-height: calc(100% - 152px);
    height: auto;
    padding: 52px 32px 100px;
    position: relative;
  }

  @media only screen and (max-width: 728px) {
    .date {
      display: none;
    }
  }

  .date{
    float: right;
    margin-right: 322px;
  }

  .head_title {
    width: 100%;
    height: auto;
    margin-top: 42px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .head_left, .head_right {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  .room_name {
    font-family: LibreBaskervilleBold;
    font-weight: 600;
    font-size: 32px;
    letter-spacing: 0;
    color: ${COLOR.BLACK_5};
    opacity: 1;
  }

  .type-badge {
    height: 24px;
    border-radius: 4px;
    padding: 0 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: NunitoSansRegular;
    font-size: ${FONT_SIZE.TN};
    font-weight: 500;
    box-sizing: border-box;
  }

  .status-badge {
    width: fit-content;
    padding: 2px 8px;
    height: 24px;
    border-radius: 99px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: NunitoSansSemiBold;
    font-size: ${FONT_SIZE.TN};
    font-weight: 600;
    box-sizing: border-box;
  }

  .favorite-icon {
    position: relative;
    z-index: ${Z_INDEXS.LV_1};
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .sub_title {
    width: fit-content;
    font-family: NunitoSansRegular;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0;
    color: ${COLOR.BLACK_6};
    opacity: 1;
    position: relative;
    margin-top: 16px;
  }

  .information {
    font-family: NunitoSansRegular;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0;
    color: #7B7B7B;
    opacity: 1;
    position: relative;
    margin-top: 8px;
  }

  .gallery {
    height: auto;
    position: relative;
    margin: 24px 0 24px 0;

    span {
      font-family: NunitoSansSemiBold;
      font-weight: 600;
      font-size: 20px;
      letter-spacing: 0;
      color: ${COLOR.BLACK_6};
      opacity: 1;
    }
  }

  /* Hide scrollbar for Chrome, Safari and Opera */
  .gallery-list::-webkit-scrollbar {
    display: none;
  }
  .gallery-list {
    overflow-x: auto;
    display: flex;

    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;
  }

  .gallery-list {
    overflow-x: scroll;
    display: flex;
    flex-wrap: row;

    > img {
      height: 128px;
      width: 192px;
      background:${COLOR.GRAY_2};
      margin-top: 10px;
      margin-bottom: 10px;
      margin-right: 8px;
      border-radius: 8px;
      object-fit: cover;
    }
  }

  .no_image{
    margin-top: 10px;
    color: ${COLOR.GRAY_3};
    background:${COLOR.GRAY_2};
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 128px;
    width: 192px;
  }

  .no_image_text {
    margin: auto;
    font-family: NunitoRegular;
  }

  .previous_button, .next_button {
    width: 70px;
  }

  .previous_button {
    position: relative;
    float: left;
    margin-top: -120px;
    margin-left: -32px;
    cursor: pointer;
  }

  .icon_left {
    position: relative;
    float: left;
    margin-top: -93px;
    margin-left: -5px;
    cursor: pointer;
  }

  .next_button {
    position: relative;
    float: right;
    margin-top: -120px;
    margin-right: -32px;
    cursor: pointer;
  }

  .icon_right {
    position: relative;
    float: right;
    margin-top: -93px;
    margin-right: -5px;
    cursor: pointer;
  }

  .schedule {
    position: relative;
  }

  .schedule_wrapper {
    border: 1px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    overflow: hidden;
  }

  .table_schedule {
    width: 100%;
    border-collapse: collapse;
  }

  .head_schedule {
    th {
      text-align: left;
      font-family: NunitoSansBold;
      font-weight: 700;
      font-size: 18px;
      color: #FAFAFA !important;
      letter-spacing: 0;
      padding: 12px 16px;
    }
  }

  .schedule_body_scroll {
    display: block;
    max-height: 281px;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .text-truncate {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    width: 100%;
  }

  .schedule_body_scroll::-webkit-scrollbar {
    width: 6px;
  }
  .schedule_body_scroll::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 4px;
  }

  .table_schedule thead, .schedule_body_scroll tr {
    display: table;
    width: 100%;
    table-layout: fixed;
  }

  .table_schedule th:nth-child(1), .schedule_data td:nth-child(1) {
    width: 23%;
  }
  .table_schedule th:nth-child(2), .schedule_data td:nth-child(2) {
    width: 60%;
  }
  .table_schedule th:nth-child(3), .schedule_data td:nth-child(3) {
    width: 7%;
  }

  .schedule_data {
    &:nth-child(even) {
      background-color: ${({ colorTheme }) => colorTheme ? `${colorTheme}33` : '#FAF7F2'};
    }
    td {
      font-family: NunitoSansRegular;
      font-weight: 400;
      font-size: 16px;
      letter-spacing: 0;
      padding: 12px 16px;
      border-bottom: 1px solid #F1F1F1;
    }
    &:last-child td {
      border-bottom: none;
    }
  }

  .schedule_data.available-row {
    cursor: pointer;
  }
  .schedule_data.available-row:hover {
    background-color: ${({ colorTheme }) => colorTheme ? `${colorTheme}4D` : '#EFE7DA'};
  }

  .book-now-link {
    font-family: NunitoSansBold;
    font-weight: 700;
    font-size: 16px;
    text-decoration: underline;
    color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
  }

  @media only screen and (max-width: 1083px) {
    .schedule {
      width: 1080px;
    }
  }

  .schedule_no_data {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 16px 16px;
  }

  .schedule_no_data_text {
    margin: 0px;
    font-family: NunitoSansRegular;
    font-weight: 400;
    font-size: 16px;
    color: ${COLOR.BLACK_6};
  }

  @media screen and (min-width:100px){
    .facility, .room-manual {
      display: flex;
      flex-wrap: wrap;
      flex: 4;
    }
  }


  .header-subtext {
    color: ${COLOR.GRAY_3};
    cursor: pointer;
    margin-left: 13px;
    font-family: NunitoBold;
    font-size: ${FONT_SIZE.XXS};
  }
  .header-subtext:hover {
    color: ${COLOR.GRAY_10};
  }

  .schedule-header {
    font-family: NunitoSansSemiBold;
    font-weight: 600;
    font-size: 20px;
    letter-spacing: 0;
    color: ${COLOR.BLACK_6};
    margin-bottom: 12px;
  }

  .schedule-table, .facility-table, .room-manual-table {
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;
  }

  .facility-header, .room-manual-header {
      font-family: NunitoSansSemiBold;
      font-weight: 600;
      font-size: 20px;
      letter-spacing: 0;
      color: ${COLOR.BLACK_6};
      opacity: 1;
      display: flex;
      flex: 1;
      margin-bottom: 12px;
    }

  .link-icon {
      text-decoration: underline;
      font-family: NunitoRegular, sans-serif;
      font-weight: 400;
      font-size: 14px;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      color: ${( props ) => props.colorTheme ? `${props.colorTheme}` : COLOR.GOLD_1};
    }
  .facility-text, .room-manual-text {
      font-family: NunitoRegular, sans-serif;
      font-weight: 400;
      font-size: 14px;
      color: ${COLOR.GRAY_27};
      margin: 0;
    }

  .facility {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .facility-item {
    background-color: ${({ colorTheme }) => colorTheme ? `${colorTheme}33` : '#FAF7F2'};
    border-radius: 4px;
    padding: 2px 8px;
    height: 28px;
    box-sizing: border-box;
    font-family: NunitoRegular, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1;
    color: ${COLOR.BLACK_6};
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
`




